import type { VueSelectProps } from 'vue-select';

export { default } from './CSelect.vue';

export interface CSelectItem<T = string, TObject = unknown> {
    value: T;
    label: string;
    name?: string;
    thumb?: string;
    deletable?: boolean;
    object?: TObject;
    disabled?: boolean;
}

export type Primitive = number | string | boolean;

export const valueReducer: VueSelectProps['reduce'] = (item) => (item as CSelectItem)?.value;
